import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { Link } from 'react-router-dom';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaSquareXTwitter
} from 'react-icons/fa6';
import { FaMapMarkerAlt, FaEnvelope , FaPhoneAlt,  } from 'react-icons/fa'; 
import '../styles/Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    setStatusMessage('Subscribing...');

    const serviceId = "service_barcrvi"; 
    const templateId = "template_9yw7m2k"; 
    const publicKey = "kwcJnsVndnqQ5hqgP";

    // Reusing the same template. Passing email in the template variables
    // Adjust variable names if the emailjs template expects different ones for newsletters.
    const templateParams = {
      email: email,
      message: 'Newsletter Subscription Request',
      full_name: 'Subscriber',
      phone: 'N/A',
      company: 'N/A'
    };

    try {
      await emailjs.send(serviceId, templateId, templateParams, publicKey);
      setStatusMessage('Subscribed successfully!');
      setEmail('');
    } catch (error) {
      console.error("Error subscribing:", error);
      setStatusMessage('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setStatusMessage(''), 5000);
    }
  };


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  //function for the Go to Top button
  const handleGoToTop = () => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer">
      <div className="newsletter-section">
        <div className="newsletter-content">
          <h3>Subscribe to our Newsletter</h3>
          <p>Get the latest updates on AI, ML, and our upcoming products.</p>
        </div>
        <form className="newsletter-form" onSubmit={handleSubscribe}>
          <input 
            type="email" 
            name="email" 
            placeholder="Enter your email address" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required 
          />
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>
        {statusMessage && (
          <p style={{ width: '100%', color: statusMessage.includes('Failed') ? '#ffaa00' : '#4caf50', marginTop: '10px', fontWeight: 'bold' }}>
            {statusMessage}
          </p>
        )}
      </div>
      
      <div className="footer-container">
        {/* Company Info Section */}
        <div className="footer-column company-info">
          <Link to="/" className="footer-logo">
            <img src="/images/logo.png" alt="Future Forbes Logo" />
            <span className="footer-company-name">Future Forbes</span>
          </Link>
          <p className="tagline">Where Vision Meets Innovation</p>
          <p className="description">
            We’re a growing software engineering company, turning ideas into success stories with fresh
            energy and proven expertise.
          </p>
          <div className="social-links">
            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/future_forbes_pvt.ltd/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://x.com/future_forbes_?t=B-pjS693dp8ArO7-J2IPQQ&s=08" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
              <FaSquareXTwitter />
            </a>
            <a href="https://www.linkedin.com/company/future-forbes-pvt-ltd/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
            <a href="https://wa.me/918885600899" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
          </div>
        </div>

        {/* Our Products Section */}
        <div className="footer-column footer-services">
          <h3>Our Products</h3>
          <div className="service-categories">
            <div className="service-category">
              <h4>Software & Solutions</h4>
              <ul>
                <li><Link to="/products" onClick={scrollToTop}>FFHRMS</Link></li>
                <li><Link to="/products" onClick={scrollToTop}>EasyXerox</Link></li>
                <li><Link to="/products" onClick={scrollToTop}>Planto</Link></li>
                <li><Link to="/products" onClick={scrollToTop}>AI Interviewer</Link></li>
                <li><Link to="/products" onClick={scrollToTop}>MasterShot</Link></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Our Services Section */}
        <div className="footer-column footer-services">
          <h3>Our Services</h3>
          <div className="service-categories">
            <div className="service-category">
              <h4>Technology</h4>
              <ul>
                <li><Link to="/services#blockchain-details" onClick={scrollToTop}>Blockchain-Based Solutions</Link></li>
                <li><Link to="/services#ai-ml-details" onClick={scrollToTop}>AI and ML Products</Link></li>
                <li><Link to="/services#embedded-iot-details" onClick={scrollToTop}>Embedded Systems and IoT</Link></li>
                <li><Link to="/services#data-science-details" onClick={scrollToTop}>Data Science</Link></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Contact Now Section */}
        <div className="footer-column contact-now">
          <h3>Contact Now</h3>
          <ul className="contact-list-modern">
            <li>
              <div className="icon-wrapper">
                <FaMapMarkerAlt />
              </div>
              <div className="contact-details">
                <strong>India (HQ)</strong>
                <span>Gachibowli, Hyderabad, Telangana</span>
              </div>
            </li>
            <li>
              <div className="icon-wrapper">
                <FaMapMarkerAlt />
              </div>
              <div className="contact-details">
                <strong>Australia</strong>
                <span>Wyndham City, Melbourne</span>
              </div>
            </li>
            <li>
              <div className="icon-wrapper">
                <FaPhoneAlt />
              </div>
              <div className="contact-details">
                <strong>Phone</strong>
                <a href="tel:+918885600899">+91 88856 00899</a>
              </div>
            </li>
            <li>
              <div className="icon-wrapper">
                <FaEnvelope />
              </div>
              <div className="contact-details">
                <strong>Email</strong>
                <a href="mailto:info@futureforbes.in">info@futureforbes.in</a>
              </div>
            </li>
          </ul>
          <div className="go-to-top-wrapper">
            <button className="scroll-to-top-btn" onClick={handleGoToTop}>
              Go to Top <span className="arrow-up">↑</span>
            </button>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="copyright">© 2026 Future Forbes | All rights reserved</p>
      </div>
    </footer>
  );
};

export default Footer;